import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-date-update-admin-config',
  templateUrl: './date-update-admin-config.component.html',
  styleUrls: ['./date-update-admin-config.component.scss']
})
export class AtwDateUpdateAdminConfig  extends AtwUpdateDbComponent  implements OnInit {

@Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  none: boolean = false; // có chọn PHONG CÁCH hay chưa (true=>chưa; false:đã chọn)

  dataAfterChange: any  = {}
  arr_link_page: any;
  id_subproject: any = "";
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ]

  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  text_style: any = [
    {
      title: 'tieu_de_1',
      desktopFontSize: '72px',
      mobileFontSize: '72px',
      name: 'h1',
      font: 21
    },
    {
      title: 'tieu_de_2',
      desktopFontSize: '48px',
      mobileFontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'tieu_de_3',
      desktopFontSize: '36px',
      mobileFontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'tieu_de_4',
      desktopFontSize: '24px',
      mobileFontSize: '24px',
      name: 'h4',
      font: 17
    },
    {
      title: 'tieu_de_5',
      desktopFontSize: '20px',
      mobileFontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'tieu_de_6',
      desktopFontSize: '18px',
      mobileFontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'van_ban',
      desktopFontSize: '18px',
      mobileFontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_nho',
      desktopFontSize: '16px',
      mobileFontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'trich_dan',
      desktopFontSize: '18px',
      mobileFontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['date-update__content']['text-shadow']
    //   && !this.class['date-update']['background-color']
    //   && this.class['date-update__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }

    if (!this.config.date_format_style)
      this.config.date_format_style = 'dd-MM-yyyy';
    if (!this.config.date_format) 
      this.config.date_format = {
        "separatorDate": "-",
        "separatorDateTime": ", ",
        "formatDate": "ddMMyyyy",
        "amPm": false,
        "hh": true,
        "mm": true,
        "ss": true,
        "timeZone": false,
        "formatTimeZone": "z",
        "separatorTimeZone": " ",
        "format": "dd/MM/yyyy"
      };
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  ngOnDestroy() {
    this.saveDataProperties();
  }
  
  
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }

  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  /**
   * Cập nhật transform
   */
  handleSetTextRotate() {
    this.class['date-update__content']['transform'] = `rotate(${this.config['transform']['rotate']}deg)`;
    this.updateClass();
    this.updateConfig();
  }
  /**
   * Cập nhật các thuộc tính border-radius
   */
  handleSetBorderRadius() {
    this.class['date-update']['border-top-left-radius'] = this.class['date-update']['border-radius'];
    this.class['date-update']['border-top-right-radius'] = this.class['date-update']['border-radius'];
    this.class['date-update']['border-bottom-left-radius'] = this.class['date-update']['border-radius'];
    this.class['date-update']['border-bottom-right-radius'] = this.class['date-update']['border-radius'];
    this.updateClass();
  }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.config['font-size']['font_size'] = this.text_style.find(style => style.name === action)[this.device+'FontSize'];
    switch(action) {
      case "Blockquote":
        this.class['date-update__content']['border-left-width'] = '10px';
        this.class['date-update__content']['padding-left'] = '10px';
        break;
      default: 
        this.class['date-update__content']['border-left-width'] = '0';
        this.class['date-update__content']['padding-left'] = '0';
    }
    this.handleSetFontSize();
  }

  /**
   * Cập nhật font-size
   */
  handleSetFontSize() {
    this.class['date-update__content']['font-size'] = this.config['font-size']['font_size'];
    this.updateClass();
    this.updateConfig();
  }

  /**
   * Cập nhật Kiểu danh sách đầu dòng, đánh số
   */
  handleListStyle(style: string) {
    if(`${style} inside none` === this.class['date-update__content--list-style']['list-style']) {
      style = "none";
      this.config['font-size']['title'] = 'p';
    }
    else {
      this.config['font-size']['title'] = 'ul';
    }

    switch(style) {
      case 'disc':
      case 'decimal':
      case 'upper-alpha':
      case 'upper-roman':
        this.class['date-update__content--list-style']['list-style'] = `${style} inside none`;
        break;
      default:
        this.class['date-update__content--list-style']['list-style'] = 'none';
    }

    this.updateClass();
  }
  
  customize = []

  /**
   * Cập nhật text-shadow cho Hiệu ứng rê chuột
   */
  handleHoverTextShadow() {
    this.objectChoosing.desktop_class['text--animation-database'].css['text-shadow'] =
      `${this.objectChoosing.desktop_class['text--animation-database'].css.text_shadow_x}px
        ${this.objectChoosing.desktop_class['text--animation-database'].css.text_shadow_y}px
        ${this.objectChoosing.desktop_class['text--animation-database'].css.text_shadow_blur}px
        ${this.objectChoosing.desktop_class['text--animation-database'].css.text_shadow_color}`;

    this.updateClass();
  }

  handleSetHoverBorderRadius() {
    this.class['text--animation-database']['css']['border-top-left-radius'] = this.class['text--animation-database']['css']['border-radius'];
    this.class['text--animation-database']['css']['border-top-right-radius'] = this.class['text--animation-database']['css']['border-radius'];
    this.class['text--animation-database']['css']['border-bottom-left-radius'] = this.class['text--animation-database']['css']['border-radius'];
    this.class['text--animation-database']['css']['border-bottom-right-radius'] = this.class['text--animation-database']['css']['border-radius'];
    this.updateConfig();
  }

  /**
   * Tạo hình dạng đường cong cho text
   */
  toggleCurveText() {
    if(this.config['font-size']['title'] != 'ul') {
      this.config['curve']['isCurve'] = !this.config['curve']['isCurve'];
      if(this.config['curve']['isCurve']) {
        this.class['date-update__content'].width = '100%';
        this.class['date-update__content']['white-space'] = 'normal';
        this.class['date-update']['overflow'] = 'unset';
      }
      else {
        this.class['date-update__content'].width = 'unset';
        this.class['date-update__content']['white-space'] = 'pre-wrap';
        this.class['date-update']['overflow'] = 'hidden';
      }

      this.updateClass();
      this.updateConfig();
    }
  }

  // Phần GRADIENT

  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image'].gradient_check) {
      this.class['date-update__content']['background-image'] = `linear-gradient(${this.config['background-image']['gradient_direction']} ${this.config['background-image']['gradient_arr_gradient']})`;
      this.class['date-update__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['date-update__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['date-update__content']['background-image'] = 'none';
      this.class['date-update__content']['-webkit-text-fill-color'] = 'unset';
      this.class['date-update__content']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['gradient_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['gradient_opacity'] / 100})`
    })
    this.config['background-image']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientText();
  }
  openbgGradient() {
    if (isPlatformBrowser(this.platformId))
    document.getElementById('input-gradient').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['gradient_background_color'])}, ${this.config['background-image']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  updateDynamic(name, value) {
    this.dataAfterChange[name] = value;
  }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // //Hàm update class
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // //Hàm update config
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  /**
   * Hàm này dùng để theo dõi những biến thay đổi và biến dataAfterChange dùng để update dữ liệu
   */
  updateCss(name, key) {
    this.dataAfterChange[name] = { ...key }
    this.saveDataProperties();
  }

  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then(
  //       (bool) => {
          
  //       },
  //       (error) => {
  //         console.error(error);
  //       }
  //     );
  // }

  /**
   * Cập nhật lưu hàm updateCss vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then((bool) => {
          
        }, error => {
          console.error(error)
        })
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
}
